// extracted by css-extract-rspack-plugin
export default {"TimeseriesChart":"TimeseriesChart--wLniq Chart--xcv6X","TimeseriesGroups":"TimeseriesGroups--T4Fe5"};